export const FreeGeneratorPreview = ({generatorType}) => {
    if (generatorType == 'certificate') {
        return (
        <>
            <h1>Free Certificate Generator</h1>
            <h2>Create professional certificates for your friends, students or peers. </h2>

            <p>Select a template, enter the details and press "Create Certificate". That's it!</p>
            <p>You can download your certificate as PDF.</p>
        </>)
    }
    if (generatorType === 'linkedin-banner') {
        return (
        <>
            <h1>Free LinkedIn Banner Generator</h1>
            <h2>Create professional LinkedIn banners to showcase your skills and achievements on LinkedIn.</h2>

            <p>Select a template, enter the details and press "Create LinkedIn Banner". That's it!</p>
            <p>You can download your banner as PDF.</p>
        </>
        )
    }
}